<template>
    <div :style="cssStyle" class="d-inline-block">
        <svg version="1.1" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.4 14.4" xml:space="preserve">
            <polygon fill="currentColor" points="10.2,14.4 3.4,7.2 10.2,0 10.9,0.7 4.8,7.2 10.9,13.7 "/>
        </svg>
    </div>
</template>
<script type="text/javascript">
    import iconDefault from '@/assets/icons/_default.js';
    export default {...iconDefault};
</script>